import { render, staticRenderFns } from "./create-workspace-dialog.vue?vue&type=template&id=462835a8&scoped=true&"
import script from "./create-workspace-dialog.vue?vue&type=script&lang=ts&"
export * from "./create-workspace-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./create-workspace-dialog.vue?vue&type=style&index=0&id=462835a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462835a8",
  null
  
)

export default component.exports